import { LRParser } from '@lezer/lr';
import { parser as PromQLParser } from './parser';

export * as ParserTerms from './parser.terms';
export const parser: LRParser = PromQLParser;
export { prettify as formatPromQL } from './prettify';
